import React from "react";
import Modal from "Components/smallModal/smallModal";
import Loader from "Components/loader/Loader";
import Button from "Components/button/Button";
import CopyToClipboard from "react-copy-to-clipboard";

import t from "Utils/translation";
import cx from "classnames";
import s from "./migrationLogModal.scss";

export default class MigrationLogModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
    };
  }

  openInBrowserWindow() {
    const styles = "max-width: 100%; overflow-x: auto; line-height: 150%; height: 100%;white-space: pre-wrap;";
    window.open().document.write(`<pre style="${styles}">${this.props.log}</pre>`);
  }

  resetStateAndClose() {
    this.setState({ copied: false });
    this.props.handleClose();
  }

  render() {
    const { opened, log, isLogLoading, isLogErrored } = this.props;

    return (
      <Modal title={t("modal.log.migration.title")} opened={opened} closeModal={this.resetStateAndClose.bind(this)}>
        {isLogLoading && <Loader {...this.props} />}

        {!isLogLoading && !isLogErrored && (
          <div className={s.bodyMigrationLogModal}>
            <pre dangerouslySetInnerHTML={{ __html: log }}></pre>

            <div className={s.wrapCopyToClipboard}>
              <CopyToClipboard text={log} onCopy={() => this.setState({ copied: true })}>
                <a className="internalLink">Copy</a>
              </CopyToClipboard>
              {this.state.copied && <div className={s.copiedMsg}>Copied!</div>}
            </div>
          </div>
        )}

        {!isLogLoading && isLogErrored && (
          <div className={s.bodyMigrationLogModal}>
            <div className="text-[--red-d10] bg-[--red-l35] rounded py-1 px-2">
              Impossibile caricare il contenuto del file di log
            </div>
          </div>
        )}

        <div className={s.footerMigrationLog}>
          <Button type="button" color="text" onClick={this.resetStateAndClose.bind(this)}>
            button.close
          </Button>

          <Button type="button" color="accent" disabled={isLogErrored} onClick={this.openInBrowserWindow.bind(this)}>
            button.openIn.newWindow
          </Button>
        </div>
      </Modal>
    );
  }
}
